import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'm14.48 6.42-6-5h-.05l-.11-.06-.16-.05L8 1.25h-.15l-.16.05-.14.08-6 5a.74.74 0 0 0-.31.62v5.8a2 2 0 0 0 2 1.95H6.1a.76.76 0 0 0 .75-.75V9.55h2.29V14a.76.76 0 0 0 .75.75h2.91a2 2 0 0 0 1.95-1.95V7a.74.74 0 0 0-.27-.58Zm-1.23 6.38a.45.45 0 0 1-.45.45h-2.16V8.8a.75.75 0 0 0-.75-.75H6.1a.75.75 0 0 0-.75.75v4.45H3.2a.45.45 0 0 1-.45-.45V7.35L8 3l5.26 4.38Z';
const draw24px = 'M22.52,11.47l-10-9.78a.85.85,0,0,0-.25-.17.77.77,0,0,0-.56,0,.82.82,0,0,0-.25.16h0l-10,9.78a.76.76,0,0,0-.17.81.75.75,0,0,0,.7.47H3.25V20A2.75,2.75,0,0,0,6,22.75H9.63a.75.75,0,0,0,.75-.75V15.15h3.24V22a.74.74,0,0,0,.75.75H18A2.75,2.75,0,0,0,20.75,20V12.75H22a.74.74,0,0,0,.69-.47A.72.72,0,0,0,22.52,11.47ZM20,11.25a.75.75,0,0,0-.75.75v8A1.25,1.25,0,0,1,18,21.25H15.12V14.4a.76.76,0,0,0-.75-.75H9.63a.75.75,0,0,0-.75.75v6.85H6A1.25,1.25,0,0,1,4.75,20V12A.76.76,0,0,0,4,11.25H3.84l8.16-8,8.16,8Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const HomeIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'home'));
HomeIcon.displayName = 'HomeIcon';
HomeIcon.propTypes = Icon.propTypes;
HomeIcon.renderIcon = props => /*#__PURE__*/React.createElement(HomeIcon, props);
export default HomeIcon;
//# sourceMappingURL=HomeIcon.js.map